import { Answer } from '../../../../../types/Survey/Answer/Answer'
import { Element, PrebuildArbeitstagSubType, PrebuildType, SliderGroup } from '../../../../../types/Survey/Element'
import { SliderGroup as AnswerSliderGroup } from '../../../../../types/Survey/Answer/Element'

const shouldBeSkipped = (elements: Element[], nextElement: Element, answer: Answer): boolean => {
  if (nextElement.prebuildType === PrebuildType.MEETING_GROESSE_BESPRECHUNG) {
    // checks if arbeitstag includes kommunikation slider with value > 0
    const arbeitstagElement = elements.find((e) => e.prebuildType === PrebuildType.ARBEITSTAG)
    if (!arbeitstagElement) return false
    const arbeitstagAnswerElement = answer.elements.find((e) => e.uuid === arbeitstagElement.uuid)
    if (!arbeitstagAnswerElement) return false
    const kommunikationSubelement = (arbeitstagElement as SliderGroup).sliders.find((s) => s.prebuildType === PrebuildArbeitstagSubType.KOMMUNIKATION)
    if (!kommunikationSubelement) return false
    const answerSubelement = (arbeitstagAnswerElement as AnswerSliderGroup).sliders.find((s) => s.uuid === kommunikationSubelement.uuid)
    if (!answerSubelement) return false
    return answerSubelement.value <= 0
  } else if (nextElement.prebuildType === PrebuildType.MEETING_GROESSE_COWORKING) {
    // checks if arbeitstag includes kollaboration slider with value > 0
    const arbeitstagElement = elements.find((e) => e.prebuildType === PrebuildType.ARBEITSTAG)
    if (!arbeitstagElement) return false
    const arbeitstagAnswerElement = answer.elements.find((e) => e.uuid === arbeitstagElement.uuid)
    if (!arbeitstagAnswerElement) return false
    const kollaborationSubelement = (arbeitstagElement as SliderGroup).sliders.find((s) => s.prebuildType === PrebuildArbeitstagSubType.KOLLABORATION)
    if (!kollaborationSubelement) return false
    const answerSubelement = (arbeitstagAnswerElement as AnswerSliderGroup).sliders.find((s) => s.uuid === kollaborationSubelement.uuid)
    if (!answerSubelement) return false
    return answerSubelement.value <= 0
  }
  return false
}

const getNextElement = (elements: Element[], answer: Answer, currentIndex: number): Element | false | 'SUBMIT' => {
  if (currentIndex < elements.length - 1) {
    let nextIndex = currentIndex + 1
    while (nextIndex < elements.length) {
      const nextElement = elements[nextIndex]
      const skip = shouldBeSkipped(elements, nextElement, answer)
      if (skip) {
        if (nextIndex === elements.length - 1) {
          return 'SUBMIT'
        } else {
          nextIndex++
        }
      } else {
        return nextElement
      }
    }
  } else {
    return false
  }
}

export default getNextElement
